import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnInit,
  ViewEncapsulation,
  inject,
} from '@angular/core';
import { TranslateService, TranslatePipe } from '@ngx-translate/core';
import { Store } from '@ngxs/store';
import { AuthState } from '@wilson/auth/core';
import { NzMessageService } from 'ng-zorro-antd/message';

import { CSVBoxButtonComponent } from '@csvbox/angular2';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ConfigOptions, ConfigService } from '@wilson/config';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzDropdownModule } from 'ng-zorro-antd/dropdown';
import { NzTooltipModule } from 'ng-zorro-antd/tooltip';
import { UserQualificationsV2ListService } from '../../service/user-qualifications-v2-list.service';

@Component({
  selector: 'wilson-csv-box-import-qualifications-v2',
  templateUrl: './csv-box-import.component.html',
  styleUrls: ['./csv-box-import.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  imports: [
    NzButtonModule,
    NzDropdownModule,
    NzTooltipModule,
    TranslatePipe,
    FontAwesomeModule,
    CSVBoxButtonComponent,
  ],
})
export class CsvBoxImportQualificationsV2Component implements OnInit {
  private cdr = inject(ChangeDetectorRef);
  private messageService = inject(NzMessageService);
  private readonly userQualificationsV2ListService = inject(
    UserQualificationsV2ListService,
  );
  private store = inject(Store);
  private translateService = inject(TranslateService);
  protected readonly config = inject<ConfigOptions>(ConfigService);

  @Input() btnText = '';
  @Input() licenseKey = '';
  @Input() hasChangePermissions = false;
  csvBoxUser = {};

  get language(): string {
    return (this.translateService.getCurrentLang() ?? '').substring(0, 2);
  }

  ngOnInit(): void {
    this.csvBoxUser = {
      root_org_unit_id: this.store.selectSnapshot(AuthState.rootOrgUnitId),
      backend_host: this.config.host,
      at: this.store.selectSnapshot(AuthState.accessToken),
    };
  }

  async imported(result: boolean): Promise<void> {
    if (result) {
      this.userQualificationsV2ListService.triggerBulkImportedQualifications();
      this.messageService.success(
        this.translateService.instant('csvbox.import.success'),
      );
    } else {
      this.messageService.error(
        this.translateService.instant('csvbox.import.error'),
      );
    }
  }

  onLoadHandler(): void {
    this.cdr.detectChanges();
  }

  onImporterReadyHandler(): void {
    this.cdr.detectChanges();
  }
}
